module.exports = function init_sticky_hero() {

  /**
   * Helps with inconsistent mobile display
   */
  function update_sticky_hero() {
    
    const hero = document.querySelector('.sticky-hero');
    if(hero) {
      const wrapper = document.querySelector('.fl-builder-content');
      const scrollTop = window.scrollY;
      
      if (scrollTop > wrapper.offsetTop + hero.offsetHeight) {
        hero.style.opacity = '0';
      } else {
        hero.style.opacity = '1';
      }
    }
    
  }
  window.addEventListener('scroll', update_sticky_hero);
  window.addEventListener('resize', update_sticky_hero);
}